import React from "react";

const OfferingList = () => {
    return (
        <div>
            <h1>Offering List</h1>
        </div>
    );
};

export default OfferingList;